// src/type-policies.ts
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var typePolicies = {
    Customer: {
        merge: true
    },
    FlightsSearchResponse: {
        merge: true
    },
    FlightsInformationResponse: {
        merge: true,
        fields: {
            flightsSelectedJourneyDetails: {
                merge: function merge(existing, incoming, param) {
                    var mergeObjects = param.mergeObjects;
                    if (!existing) {
                        return incoming;
                    }
                    if (!incoming) {
                        return existing;
                    }
                    return existing.map(function(journeyReview, index) {
                        return mergeObjects(journeyReview, incoming[index]);
                    });
                }
            }
        }
    },
    Header: {
        merge: true,
        fields: {
            redDotState: {
                read: function read() {
                    var redDotState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "NOT_VISIBLE";
                    return redDotState;
                }
            }
        }
    },
    Icon: {
        keyFields: false
    },
    Mark: {
        keyFields: false
    },
    Illustration: {
        keyFields: false
    },
    MultiItemDetailsQuery: {
        merge: true
    },
    NotificationQuery: {
        merge: true
    },
    InlineNotification: {
        keyFields: [
            "type",
            "notificationLocation"
        ]
    },
    PreBundledPackageEntryQueries: {
        merge: true
    },
    PropertyInfo: {
        merge: true
    },
    ShoppingSortAndFilterSection: {
        keyFields: false
    },
    SortAndFilterSignalEmitter: {
        keyFields: false
    },
    SortAndFilterSignalReceiver: {
        keyFields: false
    },
    Query: {
        fields: {
            globalHeader: {
                merge: true
            },
            activityReviews: {
                keyArgs: [
                    "context",
                    "activityId",
                    "selections"
                ],
                merge: function merge(existing, incoming, param) {
                    var mergeObjects = param.mergeObjects;
                    var _existing, _mergedData, _existing_reviewsDialog, _mergedData_reviewsDialog, _mergedData1;
                    if (!existing) {
                        return incoming;
                    }
                    if (!incoming) {
                        return existing;
                    }
                    var mergedData = mergeObjects(existing, incoming);
                    var _existing_comments, _mergedData_comments, _existing_reviewsDialog_comments, _mergedData_reviewsDialog_comments;
                    return _object_spread_props(_object_spread({}, mergedData), {
                        comments: _to_consumable_array((_existing_comments = (_existing = existing) === null || _existing === void 0 ? void 0 : _existing.comments) !== null && _existing_comments !== void 0 ? _existing_comments : []).concat(_to_consumable_array((_mergedData_comments = (_mergedData = mergedData) === null || _mergedData === void 0 ? void 0 : _mergedData.comments) !== null && _mergedData_comments !== void 0 ? _mergedData_comments : [])),
                        reviewsDialog: _object_spread_props(_object_spread({}, mergedData.reviewsDialog), {
                            comments: _to_consumable_array((_existing_reviewsDialog_comments = (_existing_reviewsDialog = existing.reviewsDialog) === null || _existing_reviewsDialog === void 0 ? void 0 : _existing_reviewsDialog.comments) !== null && _existing_reviewsDialog_comments !== void 0 ? _existing_reviewsDialog_comments : []).concat(_to_consumable_array((_mergedData_reviewsDialog_comments = (_mergedData1 = mergedData) === null || _mergedData1 === void 0 ? void 0 : (_mergedData_reviewsDialog = _mergedData1.reviewsDialog) === null || _mergedData_reviewsDialog === void 0 ? void 0 : _mergedData_reviewsDialog.comments) !== null && _mergedData_reviewsDialog_comments !== void 0 ? _mergedData_reviewsDialog_comments : []))
                        })
                    });
                }
            },
            propertySearch: {
                keyArgs: [
                    "context",
                    "destination",
                    "returnPropertyType",
                    "includeDynamicMap",
                    "criteria",
                    [
                        "primary",
                        "secondary",
                        [
                            "booleans",
                            "ranges",
                            "selections"
                        ]
                    ],
                    "productShoppingCriteriaInput"
                ],
                merge: function merge(existing, incoming) {
                    if (!existing) {
                        return incoming;
                    }
                    if (!incoming) {
                        return existing;
                    }
                    return _object_spread({}, existing, incoming);
                }
            },
            cruiseSearch: {
                keyArgs: [
                    "context",
                    "cruiseContext",
                    "searchInput",
                    "sortBy",
                    "sortOrder"
                ],
                merge: function merge(existing, incoming, param) {
                    var mergeObjects = param.mergeObjects;
                    if (!existing) {
                        return incoming;
                    }
                    if (!incoming) {
                        return existing;
                    }
                    return mergeObjects(existing, incoming);
                }
            }
        }
    },
    CruiseSearchFilters: {
        merge: true
    },
    SearchFormResults: {
        merge: function merge(existing, incoming, param) {
            var mergeObjects = param.mergeObjects;
            if (!existing) {
                return incoming;
            }
            if (!incoming) {
                return existing;
            }
            return mergeObjects(existing, incoming);
        }
    },
    PackagesSearchFormSelection: {
        merge: true
    },
    SailingSearchResults: {
        merge: function merge(existing, incoming, param) {
            var mergeObjects = param.mergeObjects, args = param.args;
            var _args, _existing_sailings, _existing_sailings1, _incoming_sailings_sailingList, _incoming_sailings;
            var offset = ((_args = args) === null || _args === void 0 ? void 0 : _args.offset) || 0;
            if (!existing) {
                return incoming;
            }
            if (!incoming) {
                return existing;
            }
            var mergedData = mergeObjects(existing, incoming);
            var mergedSailings = _object_spread({}, existing.sailings, incoming.sailings);
            var sailingList = ((_existing_sailings = existing.sailings) === null || _existing_sailings === void 0 ? void 0 : _existing_sailings.sailingList) ? (_existing_sailings1 = existing.sailings) === null || _existing_sailings1 === void 0 ? void 0 : _existing_sailings1.sailingList.slice(0) : [];
            for(var i = 0; i < ((_incoming_sailings = incoming.sailings) === null || _incoming_sailings === void 0 ? void 0 : (_incoming_sailings_sailingList = _incoming_sailings.sailingList) === null || _incoming_sailings_sailingList === void 0 ? void 0 : _incoming_sailings_sailingList.length); i += 1){
                sailingList[offset + i] = incoming.sailings.sailingList[i];
            }
            return _object_spread_props(_object_spread({}, mergedData), {
                sailings: _object_spread_props(_object_spread({}, mergedSailings), {
                    sailingList: sailingList
                })
            });
        }
    },
    TransportationSearchResponse: {
        merge: true
    },
    FlightsServicingResponse: {
        merge: true
    },
    Trips: {
        merge: true
    },
    Trip: {
        merge: true
    },
    OfferDetails: {
        keyFields: false
    },
    SingleUnitOfferDetails: {
        keyFields: false
    },
    ShoppingSelectableFilterOption: {
        keyFields: false
    },
    ActivitySelectedValue: {
        keyFields: [
            "id",
            "value"
        ]
    },
    ActivityOffer: {
        keyFields: [
            "id",
            "name",
            "availableTime",
            [
                "day"
            ]
        ]
    },
    ActivityTravelerSelectorDialog: {
        keyFields: false
    },
    ActivityOfferMultiSelectionOption: {
        keyFields: false
    },
    ActivityInfo: {
        merge: true
    },
    SupplyScoreDetails: {
        merge: true
    },
    PropertyNaturalKey: {
        keyFields: false
    },
    PropertyUnit: {
        keyFields: false
    },
    RatePlan: {
        keyFields: false
    },
    RatePlanAmenity: {
        keyFields: false
    },
    Console: {
        merge: true
    },
    SelectedValue: {
        keyFields: [
            "id",
            "value"
        ]
    },
    ShoppingTextInputField: {
        keyFields: false
    },
    ShoppingStepInputField: {
        keyFields: false
    },
    VirtualAgentControlInboundMessageGroup: {
        keyFields: false
    },
    VacLite: {
        keyFields: false
    },
    DirectFeedbackPrompt: {
        merge: true
    },
    HelpArticlesResultsView: {
        merge: true
    },
    ContactUsView: {
        merge: true,
        fields: {
            contactUsOptionsView: {
                merge: function merge(existing, incoming, param) {
                    var mergeObjects = param.mergeObjects;
                    if (incoming.__typename === "ContactUsErrorView") {
                        return existing;
                    }
                    return mergeObjects(existing, incoming);
                }
            },
            speakNextAvailableAgentView: {
                merge: function merge(existing, incoming, param) {
                    var mergeObjects = param.mergeObjects;
                    if (incoming.__typename === "ContactUsErrorView") {
                        return existing;
                    }
                    return mergeObjects(existing, incoming);
                }
            },
            emailUsFormView: {
                merge: function merge(existing, incoming, param) {
                    var mergeObjects = param.mergeObjects;
                    if (incoming.__typename === "ContactUsErrorView") {
                        return existing;
                    }
                    return mergeObjects(existing, incoming);
                }
            }
        }
    },
    LoyaltyRewardsResults: {
        merge: true
    },
    EGDSBasicTriggerPill: {
        keyFields: false
    },
    ShoppingRangeFilterOption: {
        keyFields: false
    },
    RangeValue: {
        keyFields: false
    },
    ClientSideAnalytics: {
        keyFields: false
    },
    ActivitySortAndFilterField: {
        keyFields: false
    },
    LodgingCard: {
        keyFields: false
    },
    LodgingPropertyCompare: {
        merge: true
    },
    BookingServicingCancelHeadsUp: {
        merge: true
    },
    EGDSCardCarouselItem: {
        keyFields: false
    },
    ActivitySearchResults: {
        merge: true
    },
    GenericDiscoveryCard: {
        keyFields: false
    },
    TripsUIItemCardVoteActionCount: {
        keyFields: [
            "action",
            [
                "itemId"
            ]
        ]
    }
};
export { typePolicies };
//# sourceMappingURL=index.js.map